// @ts-ignore - No types available for superagent-defaults
import defaults from "superagent-defaults";
import * as Cookies from "js-cookie";
import snakeCase from "lodash/snakeCase";

export function keysToSnakeCase(obj: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = {};
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      result[snakeCase(key)] = obj[key];
    }
  }
  return result;
}

export default function request(): any {
  const superagent = defaults();

  const originalQuery = superagent.query;
  superagent.query = function (params: any) {
    if (
      typeof params === "object" &&
      params !== null &&
      !Array.isArray(params)
    ) {
      const snakeParams = keysToSnakeCase(params);
      return originalQuery.call(this, snakeParams);
    }
    return originalQuery.call(this, params);
  };

  return superagent
    .set("Content-Type", "application/json")
    .set("Accept", "application/json")
    .set("X-CSRFTOKEN", Cookies.get("csrftoken") || "")
    .set("X-SessionID", Cookies.get("sessionid") || "")
    .withCredentials()
    .use((request: any) => {
      request.on("error", (error: Error) => {
        console.error(error);
      });
    });
}
